import { HolderOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { FC, useContext } from "react";

import { RowContext } from "./context/RowContext";

export const DragHandle: FC = () => {
    const { setActivatorNodeRef, listeners } = useContext(RowContext);
    return (
        <Button
            type="text"
            size="small"
            icon={<HolderOutlined />}
            style={{ cursor: "move" }}
            ref={setActivatorNodeRef}
            {...listeners}
        />
    );
};
